import { PERSON_TYPE } from "@hub/offline-order/src/constants"
import {
  getDbFromEvent,
  getSaleObjectStore,
  hasSalesStore,
  onError,
  onSuccess
} from "./indexedDbCrud.helper"

const SALES_INDEXES = [
  { name: "by_document", keyPath: "document" },
  { name: "by_created_at", keyPath: "created_at" }
]

const populateObjectStore = objectStore => {
  SALES_INDEXES.forEach(({ name, keyPath }) => {
    objectStore.createIndex(name, keyPath, { unique: false })
  })
}

const handleCreateObjStore = db => {
  const objectStore = db.createObjectStore("sales", { keyPath: "id" })
  populateObjectStore(objectStore)
}

const handleCreateObjStoreIfNecessary = db => {
  !hasSalesStore(db.objectStoreNames) && handleCreateObjStore(db)
}

const getPayload = payload => {
  return {
    id: self.crypto.randomUUID(),
    data: payload,
    seller_name: payload.seller.name,
    document:
      payload.customer.person_type === PERSON_TYPE.INDIVIDUAL
        ? payload.customer.physical.document
        : payload.customer.legal.document,
    created_at: new Date().toISOString()
  }
}

const handleSaveSale = (event, commit, payload) => {
  const objectStore = getSaleObjectStore(event, "readwrite", "sales")
  const addRequest = objectStore.add(getPayload(payload))

  addRequest.onsuccess = () =>
    onSuccess(commit, "Pedido offline salvo com sucesso")

  addRequest.onerror = event =>
    onError(event, "Erro ao abrir o banco de dados.", commit)
}

export const handleUpgradeNeeded = event => {
  const db = event.target.result

  handleCreateObjStoreIfNecessary(db)
}

export const handleSuccess = (event, commit, payload) => {
  handleCreateObjStoreIfNecessary(getDbFromEvent(event))
  commit("updateLoading", {
    show: true,
    message: "Salvando dados do pedido"
  })

  handleSaveSale(event, commit, payload)
}
